export default "__VITE_ASSET__BLihjVrn__"